import styled from 'styled-components';
import { baseVariables } from '../../styles';
import { toRem } from '@marriott/shared/mi-helper-utils';

export const Wrapper = styled.div<{ $isOpen: boolean; $isSuccess: boolean }>`
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
  background-color: ${({ $isSuccess }) =>
    $isSuccess ? '#477d00' : baseVariables.color.alert50}; // TODO: replace hex value with token when available
  box-shadow: 0 ${toRem(2)} ${toRem(8)} ${baseVariables.color.neutral30};
  align-items: center;
  position: fixed;
  inset-inline-start: 50%;
  inset-block-end: 0;
  transform: translateX(-50%);
  z-index: 9999 !important; // Ensure it appears above other elements
  padding: ${toRem(16)};
  border-radius: ${toRem(8)};
  min-height: ${toRem(60)};
  min-width: ${toRem(343)};
  max-width: ${toRem(461)};
  justify-content: space-between;

  &.wide-snackbar {
    max-width: ${toRem(498)};
  }

  .msnackbar-links {
    gap: ${toRem(8)};
  }
  .msnackbar-links {
    button {
      background-color: transparent;
    }
  }
`;
